import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircleSharp";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { signInAction } from "../../../../store/signin/actions";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    marginTop: "10%",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [signInData, setState] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = React.useState({});
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    const username = localStorage.getItem("username");
    if (username)
      setState({
        ...signInData,
        username: username,
        rememberMe: true,
      });
    // eslint-disable-next-line
  }, []);

  const validate = (fieldValues = signInData) => {
    let temp = { ...errors };

    if ("username" in fieldValues) {
      temp.username =
        fieldValues.username === "" ? "User ID or Email is required" : "";
    }

    if ("password" in fieldValues) {
      temp.password = fieldValues.password === "" ? "Password is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const updateField = (e) => {
    e.preventDefault();
    setState({
      ...signInData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckBox = () => {
    setState({
      ...signInData,
      rememberMe: !signInData.rememberMe,
    });
  };
  const SubmitSignIn = (event) => {
    if (event.type === "click" || event.which === 13) {
      event.preventDefault();
      if (validate()) {
        if (signInData.rememberMe)
          localStorage.setItem("username", signInData.username);
        else localStorage.removeItem("username", signInData.username);
        dispatch(signInAction(signInData));
      }
    }
  };
  return (
    <React.Fragment>
      <Container
        onKeyDown={SubmitSignIn}
        component="main"
        maxWidth="xs"
        className={classes.Appcss}
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar} style={{ backgroundColor: "rgb(22, 177, 255)" }}>
            <AccountCircleIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <div className={classes.form} noValidate>
            <TextField
              value={signInData.username}
              onChange={updateField}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="User ID or Email"
              name="username"
              autoComplete="email"
              autoFocus
              {...(errors.username && {
                error: true,
                helperText: errors.username,
              })}
            />
            <TextField
              value={signInData.password}
              onChange={updateField}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              {...(errors.password && {
                error: true,
                helperText: errors.password,
              })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={signInData.rememberMe}
                  onChange={handleCheckBox}
                  color="primary"
                />
              }
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{ backgroundColor: "rgb(22, 177, 255)" }}
              onClick={SubmitSignIn}
            >
              Log In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link
                  onClick={() => history.push("/forgotPassword")}
                  variant="body2"
                >
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link  onClick={() => history.push("/signUp")} variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
}
